import axios from 'axios'
import { Message } from 'element-ui'
const mimeMap = {
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    zip: 'application/zip'
}

const baseUrl = VUE_APP_URL
export function downLoadZip (str, filename) {
    var url = baseUrl + str
    axios({
        method: 'get',
        url: url,
        responseType: 'blob',
    }).then(res => {
        resolveBlob(res, mimeMap.zip)
    })
}
/**
 * 解析blob响应内容并下载
 * @param {*} res blob响应内容
 * @param {String} mimeType MIME类型
 */
export function resolveBlob (res, mimeType) {
    const aLink = document.createElement('a')
    var blob = new Blob([res.data], { type: mimeType })
    // //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
    var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
    var contentDisposition = decodeURI(res.headers['content-disposition'])
    var result = patt.exec(contentDisposition)
    var fileName = result[1]
    fileName = fileName.replace(/\"/g, '')
    aLink.href = URL.createObjectURL(blob)
    aLink.setAttribute('download', fileName) // 设置下载文件名称
    document.body.appendChild(aLink)
    aLink.click()
    document.body.removeChild(aLink);
}

export function common ({ url = '', params = {}, name = '' }) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: baseUrl + url,
            responseType: 'blob',
            params
        }).then(async (res) => {
            const isLogin = await blobValidate(res.data);
            if (isLogin) {
                const contentDisposition = decodeURI(res.headers['content-disposition'])

                const fileName =
                    name || contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1]

                const blob = new Blob([res.data], { type: res.data.type })

                // 创建 href 超链接，点击进行下载
                window.URL = window.URL || window.webkitURL
                const href = URL.createObjectURL(blob)
                const downA = document.createElement('a')
                downA.href = href
                downA.download = fileName
                downA.click()
                // 销毁超连接
                window.URL.revokeObjectURL(href)

                resolve(true)
            } else {
                Message.error('导出失败！');
                reject(false)
            }
        })
    })
}

async function blobValidate (data) {
    try {
        const text = await data.text();
        JSON.parse(text);
        return false;
    } catch (error) {
        return true;
    }
}
